/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import DialogModal from '../../../components/modal/DialogModal';
import adminServices from '../../../services/adminServices';

const AddChapterDialog = ({
  open,
  onClose,
  userId,
  onSuccess,
  editData,
  assessmentSourceId,
  moduleType,
  onNotify,
}) => {
  const [formData, setFormData] = useState({
    chapterName: '',
    difficulty: '',
  });
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (editData) {
      setFormData({
        chapterName: editData.module_name || '',
        difficulty: editData.complexity_level,
      });
      return;
    }

    setFormData({
      chapterName: '',
      difficulty: '',
    });
  }, [editData, open]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const validateForm = () => {
    if (!formData.chapterName.trim()) {
      onNotify?.('Please enter a chapter name');
      return false;
    }
    if (!formData.difficulty) {
      onNotify?.('Please select a difficulty level');
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (isSaving) return;

    if (!validateForm()) {
      return;
    }

    setIsSaving(true);
    try {
      const chapterData = {
        module_name: formData.chapterName,
        complexity_level: formData.difficulty,
        assessment_source_id: assessmentSourceId,
        module_type: moduleType,
      };

      if (editData?.id) {
        await adminServices.updateChapterInSource(chapterData, editData.id);
        onNotify?.('Chapter updated successfully');
      } else {
        await adminServices.createChapterInSource(chapterData, userId);
        onNotify?.('Chapter created successfully');
      }

      onClose?.();
      onSuccess?.();
    } catch (error) {
      console.error('Error saving chapter:', error);
      onNotify?.('Failed to save chapter');
    } finally {
      setIsSaving(false);
    }
  };

  let submitLabel = 'Create Chapter';
  if (isSaving) {
    submitLabel = 'Saving...';
  } else if (editData) {
    submitLabel = 'Update Chapter';
  }

  return (
    <DialogModal
      open={open}
      handleClose={onClose}
      title={editData ? 'Edit Chapter' : 'Create New Chapter'}
      maxWidth="lg"
      showCloseIcon
    >
      <div className="space-y-4">
        <div>
          <label htmlFor="chapter-name" className="block text-sm font-medium text-gray-700 mb-1">
            Chapter Name <span className="text-red-500" aria-hidden="true">*</span>
          </label>
          <textarea
            id="chapter-name"
            name="chapter-name"
            placeholder="Chapter Name..."
            value={formData.chapterName}
            onChange={(e) => handleChange('chapterName', e.target.value)}
            rows={4}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 resize-none"
          />
        </div>

        <div>
          <label htmlFor="chapter-difficulty" className="block text-sm font-medium text-gray-700 mb-1">
            Difficulty  <span className="text-red-500" aria-hidden="true">*</span>
          </label>
          <select
            id="chapter-difficulty"
            name="chapter-difficulty"
            value={formData.difficulty}
            onChange={(e) => handleChange('difficulty', e.target.value)}
            className="w-full mt-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
          >
            <option value="" disabled>
               Select difficulty
            </option>
            <option value="easy">Easy</option>
            <option value="medium">Medium</option>
            <option value="hard">Hard</option>
          </select>
        </div>
      </div>

      <div className="flex items-center justify-end gap-3 mt-6 pt-4 border-t border-gray-200">
        <button
          type="button"
          id="cancel-chapter-btn"
          onClick={onClose}
          className=" border border-[#e5e7eb] px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg font-medium transition-colors"
        >
          Cancel
        </button>
        <button
          type="button"
          id="submit-chapter-btn"
          onClick={handleSubmit}
          disabled={isSaving}
          className={`px-4 py-2 rounded-lg font-medium transition-colors ${
            isSaving
              ? 'bg-indigo-400 text-white cursor-not-allowed'
              : 'bg-indigo-600 hover:bg-indigo-700 text-white'
          }`}
        >
          {submitLabel}
        </button>
      </div>
    </DialogModal>
  );
};

export default AddChapterDialog;